var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visiable)?_c('div',{staticClass:"tz-dialog"},[_c('div',{staticClass:"dlg-line",domProps:{"innerHTML":_vm._s(_vm.seachKeyword(_vm.msg, '一次性答完', '不可中途关闭答题页面'))}}),_vm._v(" "),_c('div',[_c('b-button',{on:{"click":_vm.cancel}},[_vm._v("取消")]),_vm._v(" "),_c('b-button',{on:{"click":_vm.confirm}},[_vm._v("确认")])],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-543a11fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dialog/confirmdialog.vue
// module id = null
// module chunks = 